/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView, IViewInfo } from "../../../view/IView";
import { IEditor } from "../../../IEditor";
import { LayoutState } from "../../../ui/components/Layout/LayoutState";
import { GettingStartedLayoutConfig } from "./Layout";
import { ProductSupportService } from "../../../productSupport/ProductSupportService";
import { ResourceService } from "../../../resources/ResourceService";

interface IGettingStartedParams {}

export class GettingStarted implements IView<IGettingStartedParams> {
	private productSupportSvc: ProductSupportService;
	private resourceService: ResourceService;

	private layout = new LayoutState(GettingStartedLayoutConfig);

	public constructor(private dc: IEditor) {
		this.productSupportSvc = dc.get("productSupportService");
		this.resourceService = dc.get("resourceService");
	}

	public async init(params: IGettingStartedParams, id: string): Promise<void> {}

	public getProductSupportService(): ProductSupportService {
		return this.productSupportSvc;
	}

	public getLayout(): LayoutState {
		return this.layout;
	}

	public getViewInfo(): IViewInfo {
		return {
			label: "Getting Started",
			icon: "mdi/party-popper",
			canClose: true,
			isModified: false,
			renderWhenNotActive: true
		};
	}

	public dispose(): void {}
}
